import PropTypes from 'prop-types';
import React from 'react';

import Dropdown from '@grnhse/seedling/lib/azalea/components/dropdown_select';
import { standardRequest } from 'shared/utils/request';
import { withLocalePrefix } from 'shared/utils/translation';

const t = withLocalePrefix('shared');
export default class TimeZoneSelect extends React.Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    className: PropTypes.string,
    clearable: PropTypes.bool,
  };

  static defaultProps = {
    clearable: false,
  };

  constructor(props) {
    super(props);

    this.state = {
      options: [],
      isLoading: true,
    };
  }

  componentDidMount() {
    standardRequest.get('/time_zones').then((response) => {
      this.setState({
        options: response.data.time_zones,
        isLoading: false,
      });
    });
  }

  render() {
    const { value } = this.props;
    const valueOption =
      typeof this.props.value === 'string'
        ? this.state.options.find((o) => o.value === value)
        : value;

    return (
      <Dropdown
        openOnFocus={true}
        isLoading={this.state.isLoading}
        value={valueOption}
        onChange={this.props.onChange}
        placeholder={t('time.time_zone')}
        options={this.state.options}
        className={this.props.className}
        clearable={this.props.clearable}
        menuPosition={this.props.menuPosition}
      />
    );
  }
}
